/*eslint-disable */
import React, { useEffect, useState } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import moment from "moment";
import { Form as FormUi, Container, TextArea, Button, Input, Segment, Table, Dropdown, Icon, Search, Header, Divider, ButtonGroup, Grid } from "semantic-ui-react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { min, isEmpty } from "lodash";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import {
  createShipmentDispatcher,
  deleteAllOrderDispatcher,
} from "../../redux/actions/shipmentAction";
import MandatoryMark from "../common/mandatorymark";
import { DateData } from "../dynamicComponent/datepick";
import ModalCreateRoute from "../createShipmentComponent/modalCreateRoute";
import ShowAddress from "../dynamicComponent/showAddress";
import ConsigneeWithCreate from "../dynamicComponent/consigneeWithCreate";
import ConsignorWithCreate from "../dynamicComponent/consignorWithCreate";
import ModalCreateConsignee from "../createShipmentComponent/modalCreateConsignee";
import ModalCreateConsignor from "../createShipmentComponent/modalCreateConsigner";
import BillingPartyWithCreate from "../dynamicComponent/billingPartyWithCreate";
import BillingPartyBranch from "../dropdowns/billingPartyBranch";
import ModalCreateBillingParty from "../createShipmentComponent/modalCreateBillingParty";
import BranchDropdown from "../dropdowns/branchDropdown";

const DeliveryDetails = ({
  values,
  vehicleTypeMaster,
  setFieldValue,
  touched,
  errors,
  handleSubmit,
  shipment,
  shipmentEdit,
  routeCodes,
  routeNames,
  mode,
  isSubmitting,
  deleteAllOrderDispatcher,
  t,
  props
}) => {

  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
  }, [editMode])

  const [routeAddressState, setRouteAddressState] = useState("");
  const [masterState, setMasterState] = useState("");
  const getMasterBranchSelected = (branchCode, branchData) => {
    const addedMasterBranchObject = branchData.find(
      (data) => data.branchId === branchCode
    );
    //setMasterState(addedMasterBranchObject.stateId);
  };

  const [consignorAddressState, setConsignorAddressState] = useState("");
  const [consigneeAddressState, setConsigneeAddressState] = useState("");
  /* const setBillingBranch = (billingBranch) => {
    setBillingBranchState(billingBranch);
  }; */

  const [billingBranchState, setBillingBranchState] = useState("");
  const [billingPartyBranchList, setBillingPartyBranchList] = useState("");
  const setBillingBranch = (billingBranch) => {
    setBillingBranchState(billingBranch);
  };

  const [billingPartyBranch, setBillingPartyBranch] = useState("");
  const setBillingPartyBranchSelected = (
    billingBranchCode,
    billingBranchData
  ) => {
    const addedBillingBranchObject = billingBranchData
      .find
      //(data) => data.branchCode === branchCode
      ();
    //setBillingBranchState(addedBillingBranchObject.stateId);
  };


  return (
    <React.Fragment>
      <React.Fragment>
        {/* <h2>Delivery details</h2>
      <h4>EDIT button</h4>

      form */}

        <Segment className="mt-90">
          <div>
            <Header as='h3' className="heading-01" content='Delivery Details' textAlign='left' />

            <div className="header-btn">
              <Button size="mini" color="green" icon inverted labelPosition='left' onClick={(e) => { e.preventDefault(); e.stopPropagation(); setEditMode(!editMode) }}>
                <Icon name='edit' />
                Edit
              </Button>
              {editMode ?
            <Button.Group size="mini">
              <Button>Cancel</Button>
              <Button.Or />
              <Button positive>Save</Button>
            </Button.Group>
            :''}
            </div></div>
          <Divider clearing />
          <Formiker>

            <FormUi.Field>

              <Grid container columns={4} stackable>

                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Delivery Number: </label>
                    {editMode ?
                      <Input fluid Field placeholder='DN0112' />
                      :
                      'DN00112'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    {/* <label>Port Terminal: </label>
                    {editMode ?
                      <>
                        <Input fluid Field placeholder='Mumbai' />
                        <div className="address">
                          <span className="red">Address: </span>715, Neelkanth Corporate Park, Vidyavihar W, Mumbai 86 | <span className="red">City: </span> Mumbai</div>
                      </>
                      :
                      'Mumbai'} */}

                    {localStorage.getItem('customerNumber') == 549 ?
                      <label className="">
                        Port terminal
                      </label>
                      :
                      <label className="required-form-element">
                        Port terminal
                      </label>
                    }
                     {editMode ?
                      <Fieldmik
                      disabled={mode == "view" ? true : false}
                      // placeholder={
                      //   values.deliveries[i].consignee_placeholder
                      // }
                     component={ConsigneeWithCreate}
                      // name={`deliveries[${i}].consignee_code`}
                      // consigneeRaw={`deliveries[${i}].consigneeRaw`}
                      // consignee_placeholder={`deliveries[${i}].consignee_placeholder`}
                      // setRaw="consigneeRaw"
                      //fillAddressState={setConsigneeAddressState}
                      error={
                        touched.consignee && errors.consignee ? true : false
                      }
                    />
                        :'Port Address'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Delivery Location: </label>
                    {editMode ?
                    <Fieldmik
                                // disabled={mode == "view" ? true : false}
                                // placeholder={
                                //   values.deliveries[i].consignor_placeholder
                                // }
                                component={ConsignorWithCreate}
                                // name={`deliveries[${i}].consignor_code`}
                                // consignorRaw={`deliveries[${i}].consignorRaw`}
                                // consignor_placeholder={`deliveries[${i}].consignor_placeholder`}
                                // setRaw="consignorRaw"
                                // //fillAddressState={setConsignorAddressState}
                                // error={
                                //   touched.consignor && errors.consignor ? true : false
                                // }
                              />
                              :
                              'Shyan Pvt. Ltd.'}
                    {/* {editMode ?
                      <Input fluid Field placeholder='Shyan Pvt. Ltd.' />
                      :
                      'Shyan Pvt. Ltd.'} */}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Booking Branch: </label>
                    {editMode ?
                      <Input fluid Field placeholder='Mumbai' />
                      :
                      'Mumbai'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                  <label> {/* {t("shipment_form.billing_party.title") || */}
                                  Billing Party
                              </label>
                              {editMode ?
                              <Fieldmik
                                disabled={mode == "view" ? true : false}
                                //placeholder={values.billing_party_placeholder}
                                // placeholder={
                                  // values.deliveries[i].billing_party_placeholder
                                
                                component={BillingPartyWithCreate}
                                // placeholderName={`deliveries[${i}].billing_party_placeholder`}
                                // name={`deliveries[${i}].billing_party_id`}
                                dataId="billingBranchState"
                                setBillingBranch={setBillingBranch}
                              />
                              :
                              ''}
                    {/* <label>Billing Party: </label>
                    {editMode ?
                      <Input fluid Field placeholder='Import' />
                      :
                      'Import'} */}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label1>Billing Party Branch</label1>
                    {editMode ?
                      <Input fluid Field placeholder='Import' />
                      :
                      'Import'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Booking Branch : </label>
                    {editMode ?
                      <Input fluid Field placeholder='Mumbai' />
                      :
                      'Mumbai'}
                  </div>
                </Grid.Column>
                <Grid.Column>

                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Container Name: </label>
                    {editMode ?
                      <Input fluid Field placeholder='CN002' />
                      :
                      'CN002'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Container Type: </label>
                    {editMode ?
                      <Input fluid Field placeholder='20 Feet' />
                      :
                      '20 Feet'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Container Pickup Date: </label>
                    {editMode ?
                      <Input fluid Field placeholder='20-10-2021' />
                      :
                      '20-01-2021'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Container drop Date: </label>
                    {editMode ?
                      <Input fluid Field placeholder='21-10-2021' />
                      :
                      '21-10-2021'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Container Drop Location: </label>
                    {editMode ?
                      <Input fluid Field placeholder='Mumbai' />
                      :
                      'Mumbai'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Storage Expiration: </label>
                    {editMode ?
                      <Input fluid Field placeholder='20-10-2021' />
                      :
                      '20-10-2021'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>Demurrage Expiration: </label>
                    {editMode ?
                      <Input fluid Field placeholder='21-10-2021' />
                      :
                      '21-10-2021'}
                  </div>
                </Grid.Column>
                <Grid.Column>
                  <div className="display-grid-center">
                    <label>ETA: </label>
                    {editMode ?
                      <FormUi.Input fluid Field placeholder='Import' />
                      :
                      'Import'}
                  </div>
                </Grid.Column>

              </Grid>
            </FormUi.Field>
          </Formiker>

          <Segment>
            <Header as='h3' className="heading-01" content='Invoice 1' textAlign='left' />
            <div className="right-float"><Button size="mini" color="blue" inverted icon labelPosition='left'>
              <Icon name='add' />
              Invoice
            </Button></div>
            <Divider clearing></Divider>
            <Formiker>
              <FormUi.Field>
                <Grid columns='equal' className="table-grid">
                  <Grid.Row className="table-grid-row">
                    <Grid.Column>Invoice No.</Grid.Column>
                    <Grid.Column>BL Number</Grid.Column>
                    <Grid.Column>Invoice</Grid.Column>
                    <Grid.Column>Weight(in Kg)</Grid.Column>
                    <Grid.Column>Invoice Date</Grid.Column>
                    <Grid.Column>Total Invoice Value</Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column><Input fluid Field placeholder='1N0001' className="mrg-lft-20" /></Grid.Column>
                    <Grid.Column><Input fluid Field placeholder='BL000001' /></Grid.Column>
                    <Grid.Column width={3}><input type="file" size="mini"></input><span><Button size="mini" color="red" inverted icon>
                      <Icon name='trash' /></Button></span></Grid.Column>
                    <Grid.Column><Input fluid Field placeholder='BL000001' /></Grid.Column>
                    <Grid.Column><Input fluid Field placeholder='BL000001' /></Grid.Column>
                    <Grid.Column><Input icon='rupee' iconPosition='left' placeholder='10000' /></Grid.Column>


                  </Grid.Row>
                </Grid>
                {/* <Table singleLine>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Invoice No.</Table.HeaderCell>
                      <Table.HeaderCell>BL Number</Table.HeaderCell>
                      <Table.HeaderCell>Invoice</Table.HeaderCell>
                      <Table.HeaderCell>Weight(in Kg)</Table.HeaderCell>
                      <Table.HeaderCell>Invoice Date</Table.HeaderCell>
                      <Table.HeaderCell>Total Invoice Value</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>

                    <Table.Row>

                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>

                    </Table.Row>

                  </Table.Body>
                </Table> */}
              </FormUi.Field>
            </Formiker>
            <br></br>
            <Header as='h3' className="heading-01" content='Product Details' textAlign='left' />
            <div className="right-float mt-20"><Button size="mini" color="blue" inverted icon labelPosition='left'>
              <Icon name='add' />
              Delivery
            </Button></div>
            <Divider clearing></Divider>
            <Grid columns='equal' className="table-grid">
              <Grid.Row className="table-grid-row">
                <Grid.Column width={2}>Product Code</Grid.Column>
                <Grid.Column width={2}>Product Name</Grid.Column>
                <Grid.Column width={3}>Product Category</Grid.Column>
                <Grid.Column>Quantity</Grid.Column>
                <Grid.Column width={2}>Packaging Type</Grid.Column>
                <Grid.Column>Rate</Grid.Column>
                <Grid.Column>Edit</Grid.Column>
                <Grid.Column>Delete</Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column className="mrg-lft-20" width={2}>PD0001</Grid.Column>
                <Grid.Column width={2}>Drin</Grid.Column>
                <Grid.Column width={3}>Ambient</Grid.Column>
                <Grid.Column>100</Grid.Column>
                <Grid.Column width={2}>Box</Grid.Column>
                <Grid.Column>1000</Grid.Column>
                <Grid.Column><Button size="mini" color="green" inverted icon>
                  <Icon name='edit' />
                </Button></Grid.Column>
                <Grid.Column><Button size="mini" color="red" inverted icon>
                  <Icon name='trash' />
                </Button></Grid.Column>
              </Grid.Row>
            </Grid>

          </Segment>
                <segment>
                
                </segment>
          {/* 
          <div className="container-fluid dip_bar">
            <div className="row">
              <div className="col-sm-10">


                <Button size="mini" color="blue" inverted icon labelPosition='left'>
                  <Icon name='add' />
                  New Delivery
                </Button>

               
              </div></div></div> */}
          <center><Button size="mini" color="blue" inverted icon labelPosition='left'>
            <Icon name='refresh' />
            Update
          </Button></center>
          <br></br><br></br>
        </Segment>


      </React.Fragment>
    </React.Fragment>
  );
};



const FormikShipment = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
  }),
  // setFieldValue("required_on", moment().format("DD/MM/yyyy hh:mm"));
  mapPropsToValues: (props) => (
    {
      //movement_type: (props.shipmentEdit ? props.shipmentEdit.movement_type : localStorage.getItem("customerNumber") != 1122 ? "primary" : "import"),
    }),
  handleSubmit(values, { setFieldValue, setSubmitting, props }) {

  },
})(DeliveryDetails);

const mapStateToProps = ({ shipment }) => {
  return {
    shipment,
  };
};

export default connect(mapStateToProps, {
  createShipmentDispatcher,
  successAlertDispatcher,
  errorAlertDispatcher,
  deleteAllOrderDispatcher,
})(translate("create_shipment")(FormikShipment));
